import React from 'react';
import { Provider } from 'react-redux';
import { store } from './storage/store';
import Navigator from './navigation';

// Bootstrap 5 + Bootstrap Icons + FontAwesome
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/gentelella.css';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <Navigator />
    </Provider>
  );
}

export default App;
